import { render, staticRenderFns } from "./CardBySide2.vue?vue&type=template&id=266eab04&scoped=true&"
import script from "./CardBySide2.vue?vue&type=script&lang=js&"
export * from "./CardBySide2.vue?vue&type=script&lang=js&"
import style0 from "./CardBySide2.vue?vue&type=style&index=0&id=266eab04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266eab04",
  null
  
)

export default component.exports